import { createSelector } from 'reselect'

import { EMPTY_OBJECT } from 'utils/emptyConstants'

import { mapTriggerFilterOptions } from './mapTriggerFilterOptions'

const EMPTY_TRACKING = {
  items: [],
  nextCursor: null,
  total: 0,
  summary: null,
  summaryLoaded: false,
  summaryError: null,
  windowFrom: null,
  windowTo: null,
  plan: null,
  summaryCompanyId: null,
  loading: false,
  loaded: false,
  error: null,
  filters: {},
  cursor: null,
  cursorHistory: [],
  selectedDetail: null,
  detailLoading: false,
  detailError: null,
  schema: [],
  config: null,
  schemaLoader: false,
  configLoader: false,
  schemaLoaded: false,
  configLoaded: false,
  schemaError: null,
  configError: null,
  accessError: null,
  accessNotice: null,
  accessPending: 0,
  accessSucceeded: 0,
  accessFailed: 0,
  accessFailureMessages: [],
}

export const selectEmailTracking = (state) => state.emailencryption?.emailTracking || EMPTY_TRACKING

export const selectTrackingCompanyId = (state) =>
  state.partnerOptions?.selectedCompany?.value ||
  state.app?.data?.id ||
  state.settings?.emailEncryption?.integration?.data?.response?.tenantId ||
  state.settings?.emailEncryption?.integration?.data?.tenantId ||
  ''

export const selectTrackedEmailDetail = createSelector(
  selectEmailTracking,
  (tracking) => tracking.selectedDetail
)

export const selectTrackedEmailDetailLoading = createSelector(
  selectEmailTracking,
  (tracking) => tracking.detailLoading
)

export const selectMessageAccessError = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessError
)

export const selectMessageAccessNotice = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessNotice
)

export const selectMessageAccessPending = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessPending
)

export const selectMessageAccessSucceeded = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessSucceeded
)

export const selectMessageAccessFailed = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessFailed
)

export const selectMessageAccessFailureMessages = createSelector(
  selectEmailTracking,
  (tracking) => tracking.accessFailureMessages
)

export const selectTriggerPoliciesAvailable = createSelector(selectEmailTracking, (tracking) =>
  Boolean(
    tracking.schemaLoaded && tracking.configLoaded && !tracking.schemaError && !tracking.configError
  )
)

export const selectTriggerFilterOptions = createSelector(selectEmailTracking, (tracking) =>
  mapTriggerFilterOptions(tracking.schema, tracking.config)
)

export const selectTrackedEmailsHasNextPage = createSelector(selectEmailTracking, (tracking) =>
  Boolean(tracking.nextCursor)
)

export const selectTrackedEmailsHasPrevPage = createSelector(
  selectEmailTracking,
  (tracking) => tracking.cursorHistory.length > 0
)

export const selectTrackedEmailsSummary = createSelector(
  selectEmailTracking,
  (tracking) => tracking.summary
)

const isExplicitlyInactive = (value) =>
  value === false || value === 'inactive' || value === 'disabled' || value === 'off'

export const selectEncryptionActive = createSelector(selectEmailTracking, (tracking) => {
  const config = tracking.config || EMPTY_OBJECT
  const pec = config.policy_engine_config || config.policyEngineConfig || EMPTY_OBJECT
  const raw = config.encryptionEnabled ?? config.encryption_enabled ?? config.enabled ?? pec.enabled

  if (isExplicitlyInactive(raw)) return false
  return true
})
